/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_PrimaryInputs */

const en_settings_primary = /** @type {(inputs: Settings_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(primary)`)
};

const he_settings_primary = /** @type {(inputs: Settings_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(ראשי)`)
};

/**
* | output |
* | --- |
* | "(primary)" |
*
* @param {Settings_PrimaryInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_primary = /** @type {((inputs?: Settings_PrimaryInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_PrimaryInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_primary(inputs)
	return he_settings_primary(inputs)
});